module.exports = __webpack_public_path__ + "media/es.029d063f.mp4";